import React from 'react'
import FrontendLayout from '../FrontendLayout'
import Hero from '../front-components/Hero'
import { ORG } from '../../data/costant'

export default function Disclaimer() {
  return (
    <FrontendLayout>
      <Hero title="DISCLAIMER OF WARRANTIES & LIMITATION OF LIABILITY" />
      <div className="container my-5 card">
        <div className="card-body">
          <h6>
            DISCLAIMER OF WARRANTIES & LIMITATION OF LIABILITY
          </h6>
          <ol>
            <li>
              <strong>Disclaimer of Warranties:</strong>
              <ol>
                <li>
                  The website and all related content are provided by {ORG.web} ({ORG.name}) on an “as is” basis without warranty of any kind, express, implied, statutory, or otherwise, including the implied warranties of title, non-infringement, merchantability, or fitness for a particular purpose.
                </li>
                <li>
                  {ORG.web} ({ORG.name}) makes no warranty that:
                  <ul>
                    <li>(i) The website or related content and services will meet customer requirements or customer’s use of the website will be uninterrupted, timely, secure, or error-free.</li>
                    <li>(ii) The results obtained from using the website or related services will be effective, accurate, or reliable.</li>
                    <li>(iii) The quality of the website, related services, or content will meet customer expectations.</li>
                    <li>(iv) Any errors or defects in the website, related services, and content will be corrected.</li>
                  </ul>
                </li>
                <li>
                  No advice or information, whether oral or written, obtained by the customer from the company or through the use of the website or related services shall create any warranty not expressly stated in the Terms of Use.
                </li>
              </ol>
            </li>
            <li>
              <strong>Liability for User Content:</strong>
              <ul>
                <li>{ORG.web} ({ORG.name}) will have no liability related to any user content arising under intellectual property rights, libel, privacy, publicity, obscenity, or other laws.</li>
                <li>{ORG.web} ({ORG.name}) disclaims all liability for the misuse, loss, modification, or unavailability of any customer’s content.</li>
              </ul>
            </li>
            <li>
              <strong>Unauthorized Account Use:</strong>
              <ul>
                <li>{ORG.web} ({ORG.name}) will not be liable for any loss that the customer may incur due to unauthorized use of their account or account information in connection with the website or related services, with or without the customer’s knowledge.</li>
              </ul>
            </li>
            <li>
              <strong>Accuracy of Information:</strong>
              <ul>
                <li>{ORG.web} ({ORG.name}) has endeavored to ensure that all the information on the website is correct, but does not warrant or make any representations regarding the quality, accuracy, or completeness of any data or information available on the website.</li>
              </ul>
            </li>
            <li>
              <strong>Service Availability:</strong>
              <ul>
                <li>{ORG.web} ({ORG.name}) shall not be responsible for delays, inability to use the website, or related functionality due to reasons beyond its control.</li>
                <li>{ORG.web} ({ORG.name}) is not liable for non-availability during periodic maintenance or unplanned suspension due to technical reasons.</li>
              </ul>
            </li>
            <li>
              <strong>Download Risks:</strong>
              <ul>
                <li>Any material, data, or content downloaded or obtained through the website is done at the customer’s own risk. The customer is solely responsible for any damage or data loss resulting from such downloads.</li>
              </ul>
            </li>
          </ol>
        </div>
      </div>
    </FrontendLayout>
  )
}
